<!-- =========================================================================================
  File Name: ECommerceCheckout.vue
  Description: eCommerce Checkout page
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
  Author: Johnny Palmer
  Author URL: http://sweetas.xyz
========================================================================================== -->

<template>
    <div id="ecommerce-checkout-demo">      
        <form-wizard
            ref="checkoutWizard"
            color="rgba(var(--vs-primary), 1)"
            :title="null"
            :subtitle="null"
            :start-index="0"
            :hide-buttons="false">
          
            <button slot="prev" class="hidden">Back</button>
            <button slot="next" class="hidden">Next</button>
            <button slot="finish" class="hidden">Finish</button>

            <!-- tab 1 content --> 
            <tab-content title="Cart" icon="feather icon-shopping-cart" class="mb-5">

                <!-- IF CART HAVE ITEMS -->
                <div class="vx-row" v-if="cartItems.length">

                    <!-- LEFT COL -->
                    <div class="vx-col lg:w-2/3 w-full relative">    
               
                        <div class="items-list-view" v-for="(item, index) in cartItems" :key="item.sku">
                            <list-view :item="item" class="mb-base">
                               
                                <!-- SLOT: ITEM META -->
                                <template slot="item-meta">
                                    <h6
                                        class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                                        @click="$router.push({name: 'ecommerce-item-detail-view', params: {item_id: item.sku }}).catch(() => {})">{{ item.name }}</h6>
                                    <p class="text-sm mb-2">sku: <span class="font-semibold cursor-pointer">{{ item.sku }}</span></p>
                                    <p v-if="item.stock > item.lowstock" class="text-success text-sm">In Stock ( {{ item.stock }} )</p>
                                    <p v-if="item.stock <= item.lowstock && item.stock > 0" class="text-warning text-sm">Low Stock  ( {{ item.stock }} )</p>
                                    <p v-if="item.stock <= 0" class="text-danger text-sm">No Stock</p>
                                </template>

                                <!-- SLOT: ACTION BUTTONS -->
                                <template slot="action-buttons">
                                    <p class="font-bold text-sm"> <small>Quantity</small>
                                     <vs-input-number 
                                     :min="1" 
                                     :max="item.limit!=-1 ?item.limit: limitQuantityValue"
                                     :value="item.quantity" 
                                     @input="updateItemQuantity($event, index, item)" 
                                     @change="updateItemQuantityOnChange($event, index, item,)" 
                                     class="pl-5 inline-flex" />
                                    </p>
                                   
                                    <!-- PRIMARY BUTTON: REMOVE -->
                                      <vs-button color="danger" type="filled" icon-pack="feather" 
                                      icon="icon-x"  @click="removeItemFromCart(item)" class="no-wrap items-center justify-center mt-5">REMOVE</vs-button>
               
                                </template>
                            </list-view>
                        </div>
                    </div>

                    <!-- RIGHT COL -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card>
                            <p class="font-semibold mb-3">Details</p>
                            
                            <div class="flex justify-between mb-2" v-for="(item) in cartItems" :key="item.sku">
                                <span class="text-grey">{{item.name}}</span>
                                <span>{{item.quantity}}</span>
                            </div>
                            <vs-divider />
                            <div class="flex justify-between font-semibold mb-3">
                                <span>Total Items</span>
                                <span class="text-success">{{cartItemsTotals}}</span>
                            </div>                    
                        </vx-card>
                        <vx-card>
                        <div class="vx-row">
                          <div class="vx-col v-1/3">
                              <vs-button class="w-full" @click="returnToPubs()" icon-pack="feather"
                                  icon="icon-arrow-left" icon-before >BACK</vs-button>
                          </div>
                            <div class="vx-col w-2/3">
                               <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()" icon-pack="feather"
                                  icon="icon-arrow-right" icon-after >CONTINUE TO DELIVERY</vs-button>
                          </div>
                        </div>
                      </vx-card>
                          
                    </div>
                </div>

                <!-- IF NO ITEMS IN CART -->
                <vx-card title="You don't have any items in your cart." v-else>
                    <vs-button @click="returnToPubs">Return to Publications</vs-button>
                </vx-card>

            </tab-content>
            <!-- tab 2 content -->
            <tab-content title="Address" icon="feather icon-home" class="mb-5">
                <div class="vx-row">

                  <!-- RIGHT COL: CONTINUE WITH SAVED ADDRESS -->
                  <div  v-if="isVolunteer"
                      class="vx-col w-1/3">
                  </div>
                  <div 
                      v-if="!isVolunteer"
                      class="vx-col w-1/3">
                    <vx-card title="Infopoint Address">
                      <div>
                        <h5 class="mt-5">{{getAddress('company')}}</h5>
                        <h5 class="mt-5"></h5>
                        <p class="mt-5">{{getAddress('address1')}}</p>
                        <p>{{getAddress('address2')}}</p>
                        <p>{{getAddress('address3')}}</p>
                        <div class="vx-row">
                          <div class="vx-col w-1/2">
                            <p>{{getAddress('town')}}</p>
                            <p>{{getAddress('country')}}</p>
                            <p>{{getAddress('postcode')}}</p>
                          </div>
                          <div class="vx-col w-1/2">
                            <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-copy" @click="copyAddress" >Use This Address</vs-button>
                          </div>
                        </div>
                      </div>
                    </vx-card>

                    <vx-card :title=" isDawleys() ? 'Dawleys Main Contact' : 'Volunteer Address'">
                      <div>
                        <h5 class="mt-5">{{getvAddress('displayName')}}</h5>
                        <h5 class="mt-5"></h5>
                        <p class="mt-5">{{getvAddress('address1')}}</p>
                        <p>{{getvAddress('address2')}}</p>
                        <p>{{getvAddress('address3')}}</p>

                        <div class="vx-row">
                          <div class="vx-col w-1/2">
                             <p>{{getvAddress('town')}}</p>
                        <p>{{getvAddress('country')}}</p>
                        <p>{{getvAddress('postcode')}}</p>
                          </div>
                          <div class="vx-col w-1/2">
                            <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-copy" @click="copyVaddress" >Use This Address</vs-button>
                          </div>
                        </div>
                      </div>
                    </vx-card>  
                  </div>
                    <div class="vx-col w-1/3">
                        <vx-card title="Delivery Address">
                            <div>                             
                              <v-select :filterable="false" :options="sw_options" label="Id"
                              @search="onSearch" v-model="sw_select">
                                <template slot="no-options">
                                  Search for Address..
                                </template>
                                <template slot="option" slot-scope="option" :label="option.Id">
                                  <div class="d-center">
                                    {{ option.Text }} <small> {{ option.Description }} </small>
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                  <div class="selected d-center">
                                    {{ option.text }}
                                  </div>
                                </template>
                              </v-select>
                              <div class="vx-row mt-2 mb-2">
                                <div class="vx-col w-full">
                                  <vs-input class="w-full" label-placeholder="Address Line 1" v-model="sw_address1" />
                                </div>
                              </div>
                              <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                  <vs-input class="w-full" label-placeholder="Address Line 2" v-model="sw_address2" />
                                </div>
                              </div>
                              <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                  <vs-input class="w-full" label-placeholder="Address Line 3"  v-model="sw_address3" />
                                </div>
                              </div>
                              <div class="vx-row mb-2">
                                <div class="vx-col w-full">
                                  <vs-input class="w-full" label-placeholder="Town" v-model="sw_town" />
                                </div>
                              </div>
                              <div class="vx-row mb-6">
                                <div class="vx-col w-1/2">
                                  <vs-input class="w-full" label-placeholder="Country" v-model="sw_country" />
                                </div>
                                <div class="vx-col w-1/2">
                                  <vs-input class="w-full" label-placeholder="Postcode" v-model="sw_postcode" />
                                </div>
                                <div class="text-right mt-6 ml-3">
                                  <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-trash-2" @click="clearAddress" >Clear</vs-button>
                                </div>  
                              </div>                          
                            </div>
                        </vx-card>
                    </div>
                    <div class="vx-col w-1/3">

                      <vx-card title="Contact">
                        <div>
                          <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                              <small class="small-title">Title</small>
                               <v-select :options="['Mr', 'Mrs', 'Ms','Dr','Sir', 'Lady']" v-model="sw_title" taggable push-tags size="large">                            
                              </v-select>
                            </div>
                          </div>
                            <div class="vx-row mb-2">
                            <div class="vx-col w-1/2">
                              <vs-input class="w-full" label-placeholder="Firstname" v-model="sw_firstname" />
                            </div>
                            <div class="vx-col w-1/2">
                              <vs-input class="w-full" label-placeholder="Surname" v-model="sw_surname" />
                            </div>
                          </div>
                          <div class="vx-row mb-2">
                            <div class="vx-col w-full">
                              <vs-input class="w-full" label-placeholder="Email" v-model="sw_email" />
                            </div>
                          </div>
                          <div class="vx-row mb-2">
                            <div class="vx-col w-1/2">
                              <vs-input class="w-full" label-placeholder="Telephone" v-model="sw_telephone" />
                            </div>
                            <div class="vx-col w-1/2">
                              <vs-input class="w-full" label-placeholder="Mobile" v-model="sw_mobile" />
                            </div>
                          </div>
                        </div>
                      </vx-card>
                      <vx-card>
                        <div class="vx-row">
                          <div class="vx-col v-1/3">
                              <vs-button class="w-full" @click="$refs.checkoutWizard.prevTab()" icon-pack="feather"
                              icon="icon-arrow-left" icon-before >BACK</vs-button>
                          </div>
                            <div class="vx-col w-2/3">
                             <!-- <vs-button  v-if="isDawleys()" class="w-full" @click="$refs.checkoutWizard.nextTab()" icon-pack="feather"  icon="icon-arrow-right" icon-after >CONTINUE TO PAYMENT</vs-button>-->
                              <vs-button  class="w-full" @click.prevent="preprocessOrder"  color="success" >Submit</vs-button>
                          </div>
                        </div>
                      </vx-card>
                    </div>
                </div>
            </tab-content>  
            <!-- <tab-content v-if="isDawleys()" title="Payment" icon="feather icon-credit-card" class="mb-5">
              <div class="vx-row">  
                <div class="vx-col w-1/6">
                  <vx-card>
                    <small>Order Source</small>
                    <v-select :options="[' ', 'Email', 'Post', 'Phone']" v-model="sw_ordertype"  size="large" @input="calculatePostage">  
                      <template slot="no-options">
                        Order Type..
                      </template>
                      <template slot="option" slot-scope="option" :label="option">
                        <div class="d-center" style="min-height:20px;">
                          {{ option.label }}
                          </div>
                      </template>
                    </v-select>  
                  </vx-card> 
                </div>              
                
                 <div class="vx-col w-1/6 relative">  
                    <vx-card>
                      <small>Postage</small>
                      <v-select :options="postageOptions"  :value="postage" v-model="postage" label="code" @input="postageSelected">   
                        <template slot="option" slot-scope="option">
                          <div class="d-center" style="min-height:20px;">
                            <b v-if="option.code ==='00.00'"> FREE </b> 
                             <b v-if="option.code !=='00.00'">£ {{option.code}} </b> 
                            <small class="pl-1">{{option.text}}</small>
                            </div>
                        </template>  
                       </v-select>            
                      <small class="pl-1">{{cartItemsTotals}} Item(s)</small> 
                    </vx-card>

                    <vx-card class="mt-2"> 
                      <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <label for="" class="vs-input--label">Amount</label>
                        <div class="vs-con-input">   
                            <input 
                              v-model.lazy="orderamount" 
                              v-money="money" 
                              class="vs-inputx vs-input--input medium" 
                              style="border: 1px solid rgba(0, 0, 0, 0.2);"
                            />
                        </div>
                      </div>
                    </vx-card>
                 </div>             

                <div class="vx-col w-2/3"> 
                  <div class="vx-row"> 

                    <div class="vx-col w-1/3 relative">  
                      <vx-card>
                        <small>Payment</small>
                        <v-select :options="paymentOptions" :value="payment"  v-model="payment"/>                 
                      </vx-card>
                    </div>                
                    <div class="vx-col w-1/3 relative">  
                      <vx-card>
                        <div v-if="payment==='Credit Card'">
                          <vs-input icon-no-border placeholder="Enter Transaction Id" label="Transaction Id"
                            v-model="transid" icon-pack="feather" icon="icon-credit-card" size="medium" class="w-full" />
                        </div>

                        <div v-if="payment==='Cheque'">
                          <vs-input icon-no-border placeholder="Name" label="Customer Name"
                            v-model="chequename" icon-pack="feather" icon="icon-user" size="medium" class="w-full mt-5" />
                          <div class="vs-component vs-con-input-label vs-input w-full mt-8 vs-input-primary">
                            <label for="" class="vs-input--label">Account Number</label>
                            <div class="vs-con-input">
                              <masked-input
                                  type="text"
                                  name="chequeaccount"
                                  class="vs-inputx vs-input--input medium hasIcon" style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                  v-model="chequeaccount"
                                  :mask="[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]"
                                  :guide="false"
                                  placeholderChar="#">
                                </masked-input>
                              <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-shield null icon-no-border"></i>
                            </div>
                          </div>
                          <div class="vs-component vs-con-input-label vs-input w-full mt-8 vs-input-primary">
                            <label for="" class="vs-input--label">Account Sort Code</label>
                            <div class="vs-con-input">
                              <masked-input
                                  type="text"
                                  name="chequesort"
                                  class="vs-inputx vs-input--input medium hasIcon" style="border: 1px solid rgba(0, 0, 0, 0.2);"
                                  v-model="chequesort"
                                  :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                  :guide="false"
                                  placeholderChar="#">
                                </masked-input>

                              <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-shield null icon-no-border"></i>
                            </div>
                          </div>
                        </div>
                      </vx-card>
                    </div> 
                    <div class="vx-col w-1/3 relative">  

                      <vx-card>
                        <div class="vx-row">
                          <div class="vx-col v-1/2">
                              <vs-button class="w-full"  @click="prevStep(this)"  icon-pack="feather"
                                  icon="icon-arrow-left" icon-before >BACK</vs-button>
                          </div>
                            <div class="vx-col w-1/2">
                               <vs-button class="w-full" @click = "save"  color="success" :disabled="!paymentValidateData()" icon-pack="feather"
                                  icon="icon-save" icon-after >SAVE</vs-button>
                          </div>
                        </div>
                      </vx-card>

                    </div>               
                  </div>
                </div>   
            </div>              
          </tab-content>  -->
        </form-wizard>
        <vs-popup background-color="rgba(255,255,255,.6)" class="" title="Order" :active.sync="popupActive">
          <p> Thank you for you order.</p>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select'
//import {Money} from 'v-money'
// import MaskedInput from 'vue-text-mask'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
const ListView = () => import('./ListView.vue')
import _ from 'lodash'
export default {
  data () {
    return {
      pcaKey: 'MR34-BM33-RH83-EA34',
      xyzId: '',
      xyzIsMultiple: false,
      limitQuantity: false,
      limitQuantityValue: 999999,
      hasAddress: false,
      popupActive: false,
      notes:'',
      notesDanger:false,
      sw_address1:'',
      sw_address2:'',
      sw_address3:'',
      sw_town:'',
      sw_country:'',
      sw_postcode:'',
      sw_addresses:[],
      sw_options:[],
      sw_select:[],
      sw_title: '',
      sw_firstname: '',
      sw_surname: '',
      sw_email: '',
      sw_telephone: '',
      sw_mobile: '',
      sw_ordertype: '',   
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '£ ',
        precision: 2,
        masked: false /* doesn't work with directive */
      },     
      orderid: '',
      orderamount:'',
      chequename:'',
      chequeaccount:'',
      chequesort:'',    
      transid:'',
      refid: '',
      payment: '',
      paymentOptions: ['Cash', 'Credit Card', 'Cheque'],
      postageOptions: [
        {code: '00.00', text: '< 100 items'}, 
        {code: '15.00', text: '101 - 500 items'}, 
        {code: '25.00', text: '501 - 1000 items'}, 
        {code: '40.00', text: '1000+ items'}
      ],
      postage:[]
    }
  },
  computed: {
    cartItems () {
      return this.$store.state.eCommerce.cartItems.slice().reverse()
    },
    cartItemsTotals () {      
      let c = 0
      this.$store.state.eCommerce.cartItems.forEach(x => {
        c += Number(x.quantity) 
      })
      return c      
    },
     isVolunteer () {
        const d = this.$store.state.AppActiveUser 
        debugger
        return d.overRideCompany == 1
    },
  },
  methods: {
    st_state () {
      return this.$store.state.dataList.details
    },
    isDawleys () {      
      return this.st_state().company === 'Dawleys'
    },
    st_volunteer(){
      const d = this.$store.state.AppActiveUser 
      debugger
      return d.overRideCompany == 1

    },
    setDefaults () {
      this.copyVaddress()
      this.sw_title = this.getDetails('title')
      this.sw_firstname = this.getDetails('firstname')
      this.sw_surname = this.getDetails('lastname')
      this.sw_email = this.getDetails('email')
      this.sw_telephone = this.getDetails('telephone')
      this.sw_mobile = this.getDetails('mobile')

      if(this.isDawleys()){
        this.sw_address1 = ''
        this.sw_address2 = ''
        this.sw_address3 = ''
        this.sw_town = ''
        this.sw_postcode = ''
        this.sw_country = '' 
        this.hasAddress = false
        this.sw_title = '' 
        this.sw_firstname = '' 
        this.sw_surname = '' 
        this.sw_email = '' 
        this.sw_telephone = '' 
        this.sw_mobile = ''         
      }

      debugger
      if(this.st_volunteer()){
         this.sw_title = '' 
         this.sw_firstname = '' 
         this.sw_surname = '' 
         this.sw_email = '' 
         this.sw_telephone = '' 
         this.sw_mobile = ''         
      }

    },
    copyAddress () {
      this.sw_address1 = this.getAddress('company')
      this.sw_address2 = this.getAddress('address1')
      this.sw_address3 = this.getAddress('address2')
      this.sw_town = this.getAddress('town')  
      this.sw_postcode = this.getAddress('postcode')
      this.sw_country = 'United Kingdom' 
      this.hasAddress = true

      // over write address line 1
      debugger
      if(this.getvAddress('overRideCompany') ==1) {
          this.sw_address1 = ''
      }

      this.updateDeliveryState()

    },
    copyVaddress () {
      this.sw_address1 = this.getvAddress('company')
      this.sw_address2 = this.getvAddress('address1')
      this.sw_address3 = this.getvAddress('address2')
      this.sw_town = this.getvAddress('town')  
      this.sw_postcode = this.getvAddress('postcode')
      this.sw_country = 'United Kingdom' 
      this.hasAddress = true
      // over write address line 1
      if(this.getvAddress('overRideCompany') ==1) {
          this.sw_address1 = ''
      }


      this.updateDeliveryState()
    },
    conCatContact () {
      const d = this.st_state()
      return `${d.title} ${d.firstname} ${d.lastname}`
    },
    clearAddress () {
      this.sw_address1 = ''
      this.sw_address2 = ''
      this.sw_address3 = ''
      this.sw_town  = ''
      this.sw_postcode = ''
      this.sw_country = '' 
      this.hasAddress = false
      this.updateDeliveryState()
    },
    updateDeliveryState () {
      const payload = {
        deliveryAddress1: this.sw_address1,
        deliveryAddress2: this.sw_address2,
        deliveryAddress3: this.sw_address3,
        deliveryTown:this.sw_town,
        deliveryCountry:this.sw_country,
        deliveryCountrySC:'GB',
        deliveryPostcode:this.sw_postcode,
        deliveryRegion:''
      }
      this.$store.dispatch('dataList/updateDeliveryDetails', payload)

    },
    isLastStep () {
      if (this.$refs.wizard) {

        return this.$refs.wizard.isLastStep
      }
      return false
    },
    getDetails (r) {      
      return this.getvAddress(r)      
    },
    getAddress (r) {      
      if (this.st_state() !== undefined) {
        const d = this.st_state()        
        return d[r]
      }
    },
     getvAddress (r) { 
      if (this.$store.state.AppActiveUser !== undefined) {
        const d = this.$store.state.AppActiveUser 
        return d[r]
      }
    },
    // TAB 1
    removeItemFromCart (item) {
      this.$store.dispatch('eCommerce/toggleItemInCart', item)
    },
    updateItemQuantity (quantity, index, item) {  

      // if this.limitQuantity  is true, thn set limit = quantity.limit
      const limit = this.limitQuantity ? item.limit : this.limitQuantityValue     
      if (quantity <= limit) {
        const itemIndex = Math.abs(index + 1 - this.cartItems.length)
        this.$store.dispatch('eCommerce/updateItemQuantity', { quantity, index: itemIndex })     
      }    
      
    },
    updateItemQuantityOnChange (k, index, item) { 

      // if this.limitQuantity  is true, thn set limit = quantity.limit
      const limit = this.limitQuantity ? item.limit : this.limitQuantityValue       
      let  nu = isNaN(Number(k.currentTarget.value)) ? Number(item.quantity) : Number(k.currentTarget.value)      
      nu  = (nu < limit) ? nu : limit     
      
      // call same functionality to do update.
      this.updateItemQuantity(nu, index, item)

    },
    resetvalues () {
      this.orderid = ''
      this.orderamount = ''
      this.chequename = ''
      this.chequeaccount = ''
      this.chequesort = ''
      this.transid = ''
      this.refid = ''
      this.payment = null      
    },
    prevStep () {      
      this.$refs.checkoutWizard.prevTab()
    },
    returnToPubs () {   
      this.resetvalues()

      const r = this.$store.state.eCommerce.ipid || ''  
      if (r !== '') {
        this.$router.push({
          name: 'pubs-view',
          params: {
            ipid: r
          }        
        })

      }
      if (r === '') {
        this.$router.push({
          name: 'page-search'  
        })
      }
    },
    preprocessOrder () { 
      
      if(this.sw_address1=='' ||  this.sw_postcode ==''){
       this.$swal({
                  title: 'Validation',
                  text: 'Please ensure you have an address / postcode in the address field',
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Close'
                })
                return
      }


      const payload = {
        firstname: this.sw_firstname,
        lastname: this.sw_surname,
        email: this.sw_email || '',
        title: this.sw_title || '',
        telephone: this.sw_telephone || '',
        mobile: this.sw_mobile || ''
      }   
      this.$store.dispatch('dataList/updateContactDetails', payload)
             .then(this.processOrder())
    },
    processOrder () {
      const _self = this
      _self.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })

      return new Promise(() => {

        // details
        debugger
        const ad = this.$store.state.dataList.details
        const ty = this.isDawleys() ? '' :ad.company
        const da = { 
          address1: this.sw_address1,
          address2: this.sw_address2,
          address3: this.sw_address3,
          title: this.sw_title,
          lastname: this.sw_surname,
          firstname: this.sw_firstname,
          company: ty.company,
          postcode: this.sw_postcode,
          email: this.sw_email,
          town: this.sw_town,
          county: '',
          country: this.sw_country,
          notes: this.notes,
          phone: this.telephone,
          mobile: this.sw_mobile,
          telephone: this.sw_title,
          refid: this.$store.state.eCommerce.ipid,
        }
 
        // cart
        const ca = this.$store.state.eCommerce.cartItems
        const cart = []
        ca.forEach(x => {       
          cart.push({
            quantity: x.quantity,
            sku: x.sku
          })
        })    
                
        const payload = {
          Details: da,
          Cart: JSON.stringify(cart),
          IpId: this.$store.state.eCommerce.ipid,
          Notes: this.notes,
          OrderValue:  this.orderamount
        }

        this.$store.dispatch('dataList/createOrder', payload)
          .then(r => {               
            this.$vs.loading.close()         
            if (r.data.result === 'Success') { 
              // set order id 
              this.orderid = r.data.ordernumber
              // // if dawleys staff, then process payment
              // if (_self.isDawleys()) {
              //   this.processPayment()
              // }              
              // if not dawleys employee then show message
              // if (!_self.isDawleys()) {
                _self.$swal({
                  title: 'Order',
                  text: `Thank you, Your Order ( ${r.data.ordernumber} ) has been created`,
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Close'
                }).then(() => {                
                  this.$store.dispatch('eCommerce/toggleAllItemsInCart')
                  this.returnToPubs() 
                })
              // }               
              if(r.data.result !=="Success"){
                this.$vs.notify({
                  title: 'Error',
                  text: 'Order has not been created',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })              
              }
            }              
          })         
      })
    },
    processPayment () { 
      const _self = this
      _self.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })         
      return new Promise(() => {

        // details
        const payload = {
          orderNumber: this.orderid,
          amount: this.orderamount,
          payment: this.payment,
          transactionId: this.transid,
          name: this.chequename,
          accountNumber: this.chequeaccount,
          sortCode: this.chequesort,
          source: this.sw_ordertype,
          postage: this.postage.code               
        }  
        
        this.$store.dispatch('dataList/createPayment', payload)
          .then(r => {       
                    
            this.$vs.loading.close()         
            if (r.data.data.includes('Status')) { 
              // set order id
              
              // if not dawleys employee then show message
              if (JSON.parse(r.data.data).Status > 0) {
                _self.$swal({
                  title: 'Order',
                  text: `Thank you, Your Order ( ${this.orderid} ) has been created`,
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Close'
                }).then(() => {                
                  this.$store.dispatch('eCommerce/toggleAllItemsInCart')
                  this.returnToPubs() 
                })
              } else {
                this.$vs.notify({
                  title: 'Error',
                  text: 'Order has not been created',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })
              }

            }              
          })
      })


    },
    onSearch (search, loading) {
      if(search.length<3)return      
      this.search(loading, search, this)
    },
    search: _.debounce((loading, search, vm) => {
      
      let cl = `https://services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.00/json3.ws?Key=${vm.pcaKey}&Country=GBR&SearchTerm=${encodeURIComponent(search)}&LastId=&SearchFor=Everything&$block=true&$cache=true`
      //if(this.xyz !=''){
      //   cl = ` https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws?Key=${key}&Text=${encodeURIComponent(search)}&IsMiddleware=false&Container=${encodeURIComponent(id)}&Origin=&Countries=&Limit=&Language=&Bias=false&Filters=`
      //  }
      if(vm.xyzIsMultiple){
        vm.onSearchMultiple(search,true)
        return
       //  cl = ` https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws?Key=${vm.pcaKey}&Text=${encodeURIComponent(search)}&IsMiddleware=false&Container=${encodeURIComponent(vm.xyzId)}&Origin=&Countries=&Limit=&Language=&Bias=false&Filters=`
      }      
     fetch(cl).then(res => {        
        res.json().then(json => {          
          vm.sw_options = json.Items
        })
      })
    }, 350),
     onSearchMultiple (search, loading) {
       this.searchMultiple(loading, search, this)
     },
     searchMultiple: _.debounce((loading, search, vm) => {
       const    cl = ` https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws?Key=${vm.pcaKey}&Text=${encodeURIComponent(search)}&IsMiddleware=false&Container=${encodeURIComponent(vm.xyzId)}&Origin=&Countries=&Limit=&Language=&Bias=false&Filters=`
       fetch(cl).then(res => {        
         res.json().then(json => {  
           vm.sw_options = json.Items
         })
       })
     }, 350),
    paymentValidateData () {     
      if (this.sw_ordertype === '' || this.orderamount.length === 0 || this.payment.length === 0) {      
        return false
      }
      let v = true

      if (this.payment === 'Credit Card' && this.transid.length === 0) {
        v = false
      }
      if (this.payment === 'Cheque') {        
        if (this.chequename.length === 0 || this.chequeaccount.length !== 8 || this.chequesort.length !== 8) {
          v = false
        }
      }
      return v
    },
    postageSelected (r) { 
      this.orderamount = r.code
    }, 
    calculatePostage () {
      const p = this.cartItemsTotals 
      let c =  p > 100 && p < 501 ? '15.00' : '00.00'
      c =  p > 500 && p < 1001 ? '25.00' :  c
      c =  p > 1000 ? '40.00' :  c         
      this.orderamount = c      
      this.postage = this.postageOptions.find(x => x.code === c)        
    },
    save () {   
      this.preprocessOrder()
    }       
  }, 
  components: {
    ListView,
    FormWizard,
    TabContent,
    'v-select': vSelect,
   // Money,
   //  MaskedInput
  },
  watch: {
    'sw_select' (payload) { 

      // if ismultiple = false then load details     
     if (payload.Description.includes(' Results')){
        this.xyzIsMultiple = 1
        this.onSearchMultiple( payload.Id, true)
        this.xyzId =payload.Id
        return
      } 
      const cl = `https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws?Key=${this.pcaKey}&Id=${encodeURIComponent( payload.Id)}&Field1Format=&Field2Format=&Field3Format=&Field4Format=&Field5Format=&Field6Format=&Field7Format=&Field8Format=&Field9Format=&Field10Format=&Field11Format=&Field12Format=&Field13Format=&Field14Format=&Field15Format=&Field16Format=&Field17Format=&Field18Format=&Field19Format=&Field20Format=&`

      fetch(cl).then(res => {        
        res.json().then(json => {
          this.xyzIsMultiple = 0
          const  r= json.Items[0]    
          
          let ln1 =''
          let _isCompany = false
          if(r.Company.length>0){
            ln1 = r.Company 
          _isCompany = true
          }

           if(r.Company.length>0 && r.BuildingName.length>0 ){
            ln1 = r.Company.concat(', ',  r.BuildingName )
            _isCompany = true
          }

           if(r.Company.length==0 && r.BuildingName.length>0 ){
            ln1 =  r.BuildingName 
          }

          this.sw_address1 = ln1
          this.sw_address2 = r.BuildingNumber.concat(' ',  r.Street )  

          // if not a company then move address 2 to address 1 
          if ( !_isCompany) {
             this.sw_address1 =  this.sw_address2
              this.sw_address2 =''
          }

          this.sw_address3 = r.District
          this.sw_town = r.City
          this.sw_postcode = r.PostalCode  
          this.sw_country = r.CountryName 

          var _ad ={
            Address1: this.sw_address1,
            Address2: this.sw_address2,
            District: this.sw_address3,
            Town: this.sw_town,
            Postcode: this.sw_postcode,
            Country: this.sw_country
          }
          console.log(_ad)

        })
      })   
    } 
  },
  created () {
    this.setDefaults()
  }
}
</script>
<style lang="scss" scoped>
.small-title {font-size: .7rem;color: rgba(0,0,0,.4);}
#ecommerce-checkout-demo {
    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
    }

    .item-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
    }

    .vue-form-wizard {
        padding-bottom: 0;

        ::v-deep .wizard-header {
            padding: 0;
        }

        ::v-deep .wizard-tab-content {
            padding-right: 0;
            padding-left: 0;
            padding-bottom: 0;

            .wizard-tab-container{
              margin-bottom: 0 !important;
            }
        }
    }
}
</style>
